import { formatEurPrice } from '.';

export const getPlanPrice = (price) => {
  return price || price !== ''
    ? !isNaN(price)
      ? formatEurPrice(price)
      : price
    : '-';
};
